import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Typography, Icon, LinkList, Notifier } from "../ecosystem";
import DataComponent from "../common/DataComponent";
import ErrorLoadingTileMessage from "../common/ErrorLoadingTileMessage";
import MiniSpinner from "../common/MiniSpinner";
import ResourceSubTile from "../dashboard/ResourceSubTile";
import HealthPlanTileUsage from "./HealthPlanTileUsage";

class HealthPlanTile extends DataComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isHealthPlanAPIRuningSlow: false
        }

        this.setMsgIfHPAPIRunsSlow = this.setMsgIfHPAPIRunsSlow.bind(this);
    }

    componentDidMount() {
        const { SecForShowMsgIfHPAPIRunsSlow } = this.props;
        setTimeout(this.setMsgIfHPAPIRunsSlow, SecForShowMsgIfHPAPIRunsSlow * 1000)
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.HealthPlanTile.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    setMsgIfHPAPIRunsSlow() {
        const { healthPlanServiceWaiting } = this.props;
        if (healthPlanServiceWaiting) {
            this.setState({ isHealthPlanAPIRuningSlow: true });
            logUI("MBHWeb.UI.HealthPlanTile.APIRuningSlow.ShowMessage", new Date(), Tools.getURLPath());
        }
    }

    shouldLoadDate() {
        const { isLoggedIn, hasHealthPlan } = this.props;
        return isLoggedIn && hasHealthPlan;
    }

    loadData() {
        const { getHealthPlanDashBoardData } = this.props;
        getHealthPlanDashBoardData();
    }

    render() {
        const { isHealthPlanAPIRuningSlow } = this.state;
        const { healthPlanData, hasHealthPlan, healthPlanUrl, healthPlanServiceError, healthPlanSuccess, healthPlanFailure, hasFirstCare, serverData, isMobile, swhpDown } = this.props;
        const HPTileName = healthPlanData && healthPlanData.PlanName ? healthPlanData.PlanName : hasFirstCare ? "FirstCare Health Plans" : "Baylor Scott & White Health Plan";
        const tileData = healthPlanData && healthPlanData.PrimaryAccumulator ? healthPlanData.PrimaryAccumulator : null;
        const showTaxData = serverData && serverData.show1095BTaxFormMessage && healthPlanData && healthPlanData.Show1095TaxMessage && !isHealthPlanAPIRuningSlow;
        const showHPTileUsage = (!healthPlanServiceError && typeof healthPlanData !== 'undefined' && healthPlanData) || (!healthPlanSuccess && !healthPlanFailure && isHealthPlanAPIRuningSlow);

        return (<ResourceSubTile
            className="hp-tile"
            heading={HPTileName}
            logName={"HealthPlan"}
            disabled={swhpDown}
            url={"/usage"}
            content={
                <div className="row hp-tile__content">
                    <div className="col-12">
                        <div className="hp-tile__body">
                            {!swhpDown
                                ? !healthPlanSuccess && !healthPlanFailure && !isHealthPlanAPIRuningSlow
                                    ? <MiniSpinner />
                                    : <>
                                        {showHPTileUsage
                                            ? <HealthPlanTileUsage
                                                apiRunningSlow={(!healthPlanSuccess && !healthPlanFailure && isHealthPlanAPIRuningSlow)}
                                                healthPlanData={tileData}
                                            />
                                            : <ErrorLoadingTileMessage errorMsg="No information available. Please try again later." />
                                        }

                                        {showTaxData &&
                                            <div className="hp-tile-tax-container">
                                                <Notifier
                                                    link={{ 
                                                        label: "View your 1095b",
                                                        to: { pathname: '/taxforms' },
                                                        onClick:() => logUI(`MBHWeb.UI.${hasFirstCare ? "FC" : "HP"}.DataTile.Clicked.TaxForm`, new Date(), Tools.getURLPath())
                                                    }}
                                                >
                                                    It's tax season!
                                                </Notifier>
                                            </div>
                                        }
                                    </>
                                : <ErrorLoadingTileMessage />
                            }
                        </div>
                        
                        <div className="hp-tile__footer">
                            <LinkList
                                list={[
                                    {
                                        text: "View Card",
                                        to: '/idcard',
                                        onClick: (e) => { logUI(`MBHWeb.UI.${hasFirstCare ? "FC" : "HP"}.DataTile.Clicked.ViewCard`, new Date(), Tools.getURLPath()); },
                                        disabled: swhpDown,
                                    },
                                    {
                                        text: "Plan Benefits",
                                        to: "/benefits",
                                        onClick: (e) => { logUI(`MBHWeb.UI.${hasFirstCare ? "FC" : "HP"}.DataTile.Clicked.Plan`, new Date(), Tools.getURLPath()); },
                                        disabled: swhpDown,
                                    },
                                    {
                                        text: "Claims",
                                        to: "/claims",
                                        onClick: (e) => { logUI(`MBHWeb.UI.${hasFirstCare ? "FC" : "HP"}.DataTile.Clicked.Claims`, new Date(), Tools.getURLPath()); },
                                        disabled: swhpDown,
                                    },
                                    {
                                        text: "Support",
                                        to: "/support",
                                        onClick: (e) => { logUI(`MBHWeb.UI.${hasFirstCare ? "FC" : "HP"}.DataTile.Clicked.Support`, new Date(), Tools.getURLPath()); },
                                        disabled: swhpDown,
                                    },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            }
        />);
    }
}

const mapStateToProps = (state) => {
    let healthPlanData = "";
    let healthPlanServiceError = "";
    let healthPlanFailure = false;
    let healthPlanServiceWaiting = false;
    let healthPlanSuccess = false;
    healthPlanServiceWaiting = state.healthPlan.isHealthPlanDataPending;
    healthPlanServiceError = state.healthPlan.healthPlanDataError;
    healthPlanFailure = state.healthPlan.isHealthPlanDataFailed;
    healthPlanSuccess = state.healthPlan.isHealthPlanDataSuccess;
    healthPlanData = state.healthPlan.healthPlanTileData;

    return {
        isLoggedIn: state.domain.li,
        hasHealthPlan: !state.common.swhpDown && state.memberships.hasAnySWHP,
        healthPlanUrl: state.session.serverData.healthPlanApiUrl + '#/?t=' + encodeURIComponent(state.domain.t),
        healthPlanCardUrl: state.session.serverData.healthPlanApiUrl + 'api/v1/card/image/pdf/front?width=1024&Bearer=' + encodeURIComponent(state.domain.t),
        healthPlanData: healthPlanData,
        healthPlanServiceWaiting: healthPlanServiceWaiting,
        healthPlanServiceError: healthPlanServiceError,
        healthPlanFailure: healthPlanFailure,
        healthPlanSuccess: healthPlanSuccess,
        swhpDown: state.common.swhpDown,
        serverData: state.session.serverData,
        hasSWHP: state.domain.hi,
        hasFirstCare: state.memberships.hasFC,
        SecForShowMsgIfHPAPIRunsSlow: state.session.serverData && state.session.serverData.SecForShowMsgIfHPAPIRunsSlow ? state.session.serverData.SecForShowMsgIfHPAPIRunsSlow : 15
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getHealthPlanDashBoardData: () => dispatch({
            type: types.LOAD_HEALTHPLANDASHBOARD_START
        }),

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HealthPlanTile);